<template>
  <div>
    <div @click="goLink('msg')">
      <a class="wrapper_con" :href="msg.outsideLink || msg.internalLink" @click.prevent="goProducts"
         v-if="msg.photoUrl">
        <div class="wrapper_flex">
          <img class="one_image" :src="msg.photoUrl" alt="">
          <div class="tow_view">广告</div>
        </div>
      </a>
    </div>

    <div class="wrapper_top" v-if="msg1.photoUrl || msg2.photoUrl || msg3.photoUrl">
      <div @click="goLink('msg1')">
        <a :href="msg1.outsideLink || msg1.internalLink" @click.prevent="goProducts">
          <div class="wrapper_item" style="width:464px;">
            <img v-if="msg1.photoUrl" :src="msg1.photoUrl" alt="">
            <div v-if="msg1.photoUrl" class="tow_view">广告</div>
          </div>
        </a>
      </div>

      <div @click="goLink('msg2')">
        <a :href="msg2.outsideLink || msg2.internalLink" @click.prevent="goProducts">
          <div class="wrapper_item" style="margin-left: 6px;">
            <img v-if="msg2.photoUrl" :src="msg2.photoUrl" alt="">
            <div v-if="msg2.photoUrl" class="tow_view">广告</div>
          </div>
        </a>
      </div>

      <div @click="goLink('msg3')">
        <a :href="msg3.outsideLink || msg3.internalLink" @click.prevent="goProducts">
          <div class="wrapper_item" style="margin-left: 6px;">
            <img v-if="msg3.photoUrl" :src="msg3.photoUrl" alt="">
            <div v-if="msg3.photoUrl" class="tow_view">广告</div>
          </div>
        </a>
      </div>

    </div>
    <!--  -->
    <div class="wrapper_ul">
      <div class="left">
        <a :href="'https://www.cv2000.cn/info?uid='+oneObj.uid" @click.prevent="goProducts">
          <div class="left_vue" v-if="slideList" style="height: 290px;" @click="goToInfo(oneObj)">
            <img v-if="oneObj" :src="oneObj.photoList[0]" :alt="oneObj.title">
            <div class="carousel-title" @click="goToInfo(oneObj)">
              <span>{{ oneObj.title }}</span>
            </div>
          </div>
        </a>
        <a :href="'https://www.cv2000.cn/info?uid='+oneTow.uid" @click.prevent="goProducts">
          <div class="left_ul" @click="goToInfo(oneTow)">
            <div class="title">{{ oneTow.title }}</div>
            <div class="text">{{ oneTow.summary }}</div>
          </div>
        </a>

      </div>
      <div class="right">
        <div @click="goToInfo(item)" v-for="(item, index) in slideList" :key="index">
          <a :href="'https://www.cv2000.cn/info?uid='+item.uid" @click.prevent="goProducts">
            <img v-if="slideList.length>0" :src="item.photoList[0]" alt="">
            <div class="text">{{ item.title }}</div>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getBlogByLevel, advertGetListByLevel, advertClick} from '../../api/index'
import {getBlogByUid} from '../../api/blogContent'

export default {
  data () {
    return {
      slideList: [],
      oneObj: {},
      oneTow: {},
      msg: {},
      msg1: {},
      msg2: {},
      msg3: {},
    }
  },
  created () {
    this.getinfo()
  },
  mouted () {

  },
  methods: {
    goProducts () {
      return
    },
    // 请求首屏幕借口
    async getinfo () {
      var params = new URLSearchParams()
      params.append('level', 1)
      params.append('useSort', 1)
      var response = await getBlogByLevel(params)
      if (response.code == this.$ECode.SUCCESS) {
        this.oneObj = response.data.records.splice(0, 1)[0]
        this.oneTow = response.data.records.splice(0, 1)[0]
        this.slideList = response.data.records
        if (this.slideList.length > 4) {
          this.slideList.length = 4
        }
      }
      await this.navMsg()
    },
    //跳转到文章详情【或推广链接】
    goToInfo (blog) {
      if (blog.type == '0') {
        let routeData = this.$router.resolve({
          path: '/info',
          query: {uid: blog.uid}
        })
        window.open(routeData.href, '_blank')
      } else if (blog.type == '1') {
        var params = new URLSearchParams()
        params.append('uid', blog.uid)
        getBlogByUid(params).then(response => {
          // 记录一下用户点击日志
        })
        window.open(blog.outsideLink, '_blank')
      }
    },
    async navMsg () {
      var params = new URLSearchParams()
      params.append('level', 1)
      params.append('size', 1)
      var response = await advertGetListByLevel(params)
      if (response.code == this.$ECode.SUCCESS) {
        if (response.data.length == 0) return
        this.msg = response.data[0]
      }
      // 左
      var params1 = new URLSearchParams()
      params1.append('level', 4)
      params1.append('size', 1)
      var response1 = await advertGetListByLevel(params1)
      if (response1.code == this.$ECode.SUCCESS) {
        if (response1.data.length != 0) {
          this.msg1 = response1.data[0]
        }
      }
      // 中
      var params2 = new URLSearchParams()
      params2.append('level', 5)
      params2.append('size', 1)
      var response2 = await advertGetListByLevel(params2)
      if (response2.code == this.$ECode.SUCCESS) {
        if (response2.data.length != 0) {
          this.msg2 = response2.data[0]
        }
      }
      // 右
      var params3 = new URLSearchParams()
      params3.append('level', 6)
      params3.append('size', 1)
      var response3 = await advertGetListByLevel(params3)
      if (response3.code == this.$ECode.SUCCESS) {
        if (response3.data.length != 0) {
          this.msg3 = response3.data[0]
        }

      }
    },
    async goLink (data) {
      var params = new URLSearchParams()
      params.append('uid', this[`${data}`].uid)
      const res = await advertClick(params)
      if (!this[`${data}`].internalLink && !this[`${data}`].outsideLink) return
      let url
      if (this[`${data}`].internalLink) {
        url = this[`${data}`].internalLink
      } else {
        url = this[`${data}`].outsideLink
      }
      window.open(url, '_blank')
    },
  },
}
</script>
<style scoped>
.wrapper_top {
  width: 100%;
  height: 90px;
  margin-top: 8px;
  display: grid;
  /* grid-gap: 10px; */
  grid-template-columns: repeat(3, 1fr);
}

.wrapper_item {
  width: 362px;
  height: 90px;
  position: relative;
  overflow: hidden;
}

.wrapper_item:hover img {
  transform: scale(1.1)
}

.wrapper_item > img {
  width: 100%;
  min-height: 100%;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.one_image {
  width: 100%;
  /* height: 168px; */
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.wrapper_ul {
  width: 100%;
  margin-top: 12px;
  display: flex;
}

.wrapper_ul > .left {
  width: 464px;
  height: 100%;
}

.wrapper_ul > .right {
  flex: 1;
  height: 434px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-left: 6px;
}

.wrapper_ul > .right > div {
  width: 362px;
  height: 214px;
  cursor: pointer;
  position: relative;
  margin-bottom: 6px;
  overflow: hidden;
}

.wrapper_ul > .right :hover img {
  transform: scale(1.1)
}

.wrapper_ul > .right img {
  width: 362px;
  /* height: 214px; */
  min-height: 214px;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.wrapper_ul > .right .text {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, #1A1A1A 160%);
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  padding: 0 20px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

}

.bannerBox {
  height: 290px;
}


.carousel-title {
  cursor: pointer;
  position: absolute;
  z-index: 10;
  bottom: 0px;
  height: 40px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, #1A1A1A 160%);
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  padding: 0 20px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.left_ul {
  width: 100%;
  height: 138px;
  background: #003F79;
  margin-top: 6px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.left_ul > .title {
  font-size: 20px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 12px;
  cursor: pointer;
}

.left_ul > .text {
  width: 408px;
  /* height: 60px; */
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.left_vue {
  position: relative;
  overflow: hidden;
}

.left_vue > img {
  width: 100%;
  /* height: 100%; */
  display: block;
  cursor: pointer;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.left :hover img {
  transform: scale(1.1)
}

.wrapper_con :hover .one_image {
  transform: scale(1.1)
}

.wrapper_flex {
  width: 100%;
  height: 90px;
  position: relative;
  overflow: hidden;
}

.tow_view {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 54px;
  height: 24px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.82);
}
</style>



// WEBPACK FOOTER //
// src/components/Recommend/index.vue